/*  Shared  */
import { Helpers, Response } from 'application/Shared/Helpers';
import { Requests } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

/*  State  */
const state = () => ({
    loaded: false,
    mainCategories: {},
    objectPayload: [],
    subCategories: {},
    subCategorySelection: {}
});

class CategoryPicker extends Component {
    constructor(props) {
        super(props);
        this.state = state();

        /* requests */
        this.requests = new Requests();
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prev) {
        const { reloadValue } = this.props;
        if (prev.reloadValue !== reloadValue) {
            this.reload();
        }
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const { doublePrompt, onError } = this.props;
        let { data } = this.props;

        if (!data) {
            try {
                const response = await axios.get('/category', {
                    cancelToken: this.requests.token(),
                    params: { category: '*', size: -1, sort: 'category' }
                });

                data = Response.getData(response);
            } catch (e) {
                debug.e('Unable to load Categories', e);
                if (onError) {
                    onError();
                }
                return;
            }
        }

        // Support for prompting category first, then prompting subCategory
        let mainCategories = {};
        const subCategories = {};
        if (doublePrompt) {
            mainCategories = data.map((a) => a.category);
            mainCategories = [...new Set(mainCategories)];
            mainCategories = mainCategories.map((a) => ({
                category: a,
                id: a
            }));

            data.forEach((opt) => {
                if (!Helpers.isset(subCategories, opt.category)) {
                    subCategories[opt.category] = [];
                }
                subCategories[opt.category].push({
                    category: opt.subCategory,
                    id: opt.id
                });
            });
        }

        const objectPayload = data
            .map((a) => ({
                category: `${a.category} / ${a.subCategory}`,
                id: a.id
            }))
            .sort((a, b) => {
                const categoryA = a.category.toUpperCase(); // ignore upper and lowercase
                const categoryB = b.category.toUpperCase(); // ignore upper and lowercase
                if (categoryA < categoryB) {
                    return -1;
                }
                if (categoryA > categoryB) {
                    return 1;
                }

                return 0;
            });

        this.setState({
            loaded: true,
            mainCategories,
            objectPayload,
            primarySelect: true,
            subCategories
        });
    };

    reload = () => {
        this.requests.cancel();
        this.setState(state(), () => this.load());
    };

    unload = () => {
        this.requests.cancel();
    };

    handleCategoryPick = (categorySelection) => {
        const { subCategories } = this.state;
        this.setState({
            labelPreValue: `${categorySelection} / `,
            primarySelect: false,
            subCategorySelection: subCategories[categorySelection]
        });
    };

    render() {
        const { doublePrompt, onOpen } = this.props;
        const {
            labelPreValue,
            loaded,
            mainCategories,
            objectPayload,
            primarySelect,
            subCategorySelection
        } = this.state;
        if (loaded && doublePrompt) {
            if (primarySelect) {
                return (
                    <ObjectPicker
                        {...this.props}
                        disableCloseOnSelect
                        objectPayload={mainCategories}
                        objectNameField="category"
                        onChange={(e) => this.handleCategoryPick(e)}
                    />
                );
            }
            return (
                <ObjectPicker
                    {...this.props}
                    objectPayload={subCategorySelection}
                    objectNameField="category"
                    labelPreValue={labelPreValue}
                    unselectedOption=""
                    onOpen={() =>
                        this.setState({ primarySelect: true }) && onOpen
                            ? onOpen
                            : true
                    }
                />
            );
        }
        return (
            loaded && (
                <ObjectPicker
                    {...this.props}
                    objectPayload={objectPayload}
                    objectNameField="category"
                />
            )
        );
    }
}

export default CategoryPicker;
